/**
 * invoicePdfSync.js — Generate the branded invoice PDF and push it to Xero
 * as an online attachment so clients downloading from the payment link get
 * our PDF instead of Xero's default rendering.
 *
 * Non-blocking: caller awaits but failures throw an Error the caller can
 * catch + toast without aborting the mailto flow.
 */

import { generateInvoicePdf } from './pdfGenerator';

/**
 * @param {object} args
 * @param {object} args.invoice
 * @param {object} args.job
 * @param {object} args.settings  — the unwrapped settings.data object
 * @param {Function} args.uploadMutateAsync — `useUploadInvoicePdfToXero().mutateAsync`
 * @returns {Promise<{ filename: string, attachmentId: string|null }>}
 */
export async function pushInvoicePdfToXero({ invoice, job, settings, uploadMutateAsync }) {
  if (!invoice?.id) throw new Error('Invoice required');
  if (!invoice.xeroInvoiceId) throw new Error('Invoice not synced to Xero yet');

  const { blob, filename } = await generateInvoicePdf({
    invoice,
    job,
    settings,
    returnBlob: true,
  });

  const result = await uploadMutateAsync({
    invoiceId: invoice.id,
    blob,
    filename,
  });

  return { filename, attachmentId: result?.attachmentId || null };
}
